// src/components/medical/ExploreMore.jsx
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import executiveSearchCardImage from "../assets/Images/medical-services/suchmethode-service.jfif";
import suchmethodeCardImage from "../assets/Images/medical-services/executive-search-service.avif";
const exploreCards = [
  {
    label: "LEISTUNGEN",
    title: "Executive Search",
    image: executiveSearchCardImage,
    to: "/medical/executive-search",
  },
  {
    label: "LEISTUNGEN",
    title: "Suchmethode",
    image: suchmethodeCardImage,
    to: "/medical/suchmethode",
  },
];

export default function ExploreMore() {
  return (
    <section className="w-full">
      <div className="container-app py-10">
        <h2 className="text-xl sm:text-3xl md:text-4xl font-semibold md:font-medium text-gray-900">
          Entdecken Sie mehr
        </h2>

        <div className="mt-6 grid gap-6 lg:grid-cols-[1.25fr_1fr]">
          {/* Left big card -> Insights */}
          <Link
            to="/medical/insights"
            className="
              group relative overflow-hidden rounded-[28px]
              bg-[#121313] text-white
              shadow-[0_18px_45px_rgba(0,0,0,0.10)]
              min-h-[230px]
              p-8 sm:p-10
              flex flex-col
            "
          >
            <p className="text-[11px] font-bold tracking-[0.14em] text-white/85">
              Einblicke
            </p>

            <h3 className="mt-4 text-3xl sm:text-4xl leading-tight font-medium">
              Unsere neuesten Überlegungen {" "}
              zur Gesundheitsbranche
            </h3>

            <div className="mt-auto flex justify-end">
              <span className="group btn btn-bg mt-auto text-gray-900">
                Erfahren Sie mehr <ArrowRight className="h-5 w-6 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-0.5" aria-hidden />
              </span>
            </div>
          </Link>

          {/* Right stacked cards (SPLIT layout exactly like screenshot) */}
          <div className="grid gap-6">
            {exploreCards.map((c) => (
              <Link
                key={c.title}
                to={c.to}
                className="
                  group relative overflow-hidden rounded-[28px]
                  bg-[#f1eeea]
                  shadow-[0_14px_35px_rgba(0,0,0,0.08)]
                  h-[120px] sm:h-[128px]
                "
              >
                <div className="flex h-full">
                  {/* LEFT (text area) */}
                  <div className="flex-1 px-7 py-6">
                    <p className="text-[11px] font-bold tracking-[0.14em] text-gray-800/80">
                      {c.label}
                    </p>
                    <h4 className="mt-2 text-xl sm:text-2xl font-medium text-gray-900 leading-snug">
                      {c.title}
                    </h4>
                  </div>

                  {/* RIGHT (image panel) */}
                  <div className="relative w-[42%] sm:w-[44%] overflow-hidden">
                    <img
                      src={c.image}
                      alt={c.title}
                      className="
                        h-full w-full object-cover
                        transition-transform duration-700 ease-out
                        group-hover:scale-[1.05]
                      "
                      loading="lazy"
                    />

                    {/* subtle tint only on image side (changes on hover) */}
                    <div
                      className="
                        absolute inset-0
                        bg-black/0
                        transition-colors duration-300
                        group-hover:bg-black/10
                      "
                    />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

